module.exports = __webpack_public_path__ + "img/0-85.dadfef62.jpg";